import { COMMON_FUNCTION_NAME, FunctionResult } from "@nova/common-interfaces";
import { Functions, httpsCallable } from "@angular/fire/functions";
import { Injectable } from "@angular/core";
import { CommonPagedReadOnlyService } from "./common-paged-readonly.service.mjs";

@Injectable({ providedIn: "root" })
export abstract class CommonPagedService<T, K> extends CommonPagedReadOnlyService<T, K> {
  // #region Properties (3)

  public abstract insertFunctionName: COMMON_FUNCTION_NAME;
  public abstract mergeFunctionName: COMMON_FUNCTION_NAME;
  public abstract updateFunctionName: COMMON_FUNCTION_NAME;

  // #endregion Properties (3)

  // #region Constructors (1)

  constructor(functions: Functions) {
    super(functions);
  }

  // #endregion Constructors (1)

  // #region Public Methods (3)

  /**
   * Insert new object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async insert(obj: T, refresh: boolean = false): Promise<FunctionResult<T>> {
    this.isLoading(true);
    console.debug("Calling Function", this.insertFunctionName.toString());

    return new Promise<FunctionResult<T>>((resolve, reject) => {
      const callable = httpsCallable<T, FunctionResult<T>>(
        this.functions,
        this.insertFunctionName.toString()
      );
      callable(obj)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  /**
   * Mereg object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async merge(obj: T, refresh: boolean = false): Promise<FunctionResult<T>> {
    this.isLoading(true);
    console.debug("Calling Function", this.updateFunctionName.toString());

    return new Promise<FunctionResult<T>>((resolve, reject) => {
      const callable = httpsCallable<T, FunctionResult<T>>(
        this.functions,
        this.mergeFunctionName.toString()
      );
      callable(obj)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  /**
   * Update object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async update(obj: T, refresh: boolean = false): Promise<FunctionResult<T>> {
    this.isLoading(true);
    console.debug("Calling Function", this.updateFunctionName.toString());

    return new Promise<FunctionResult<T>>((resolve, reject) => {
      const callable = httpsCallable<T, FunctionResult<T>>(
        this.functions,
        this.updateFunctionName.toString()
      );
      callable(obj)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  // #endregion Public Methods (3)
}
